const API_BASE = process.env.REACT_APP_API_URL || '/api/v1';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export { API_BASE, BACKEND_URL };
